import { render, staticRenderFns } from "./keyword-multiple-editor.vue?vue&type=template&id=3ceccff0&scoped=true&"
import script from "./keyword-multiple-editor.vue?vue&type=script&lang=js&"
export * from "./keyword-multiple-editor.vue?vue&type=script&lang=js&"
import style0 from "./keyword-multiple-editor.vue?vue&type=style&index=0&id=3ceccff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceccff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSwitch,VTextField})
